import React, {useState, useEffect, useContext} from 'react';
import {useWindowSize} from 'react-use';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import {AppContext, AppContextProvider} from './state';
import {Library} from './pages/library';
import {OpenApiContextProvider} from './openapi-context';
import {parse} from 'qs';

import {SessionContext} from './session-context-provider';

const MainRoute = ({mobile}) => {
    const {backend} = useContext(AppContext);

    function transformLocation(inputLocation) {
        if (inputLocation.search) {
            try {
                const queryStringParsed = parse(inputLocation.search.substring(1));
                if (queryStringParsed.f === undefined) {
                    return inputLocation;
                }
                return {
                    ...inputLocation,
                    pathname: queryStringParsed.f,
                };
            } catch (err) {
                console.error('UNABLE TO PROCESS F PARAM', err);
                return inputLocation;
            }
        } else {
            return inputLocation;
        }
    }

    return (
        <Route
            render={(routeProps) => (
                <Switch location={transformLocation(routeProps.location)}>
                    <Route path="">
                        <OpenApiContextProvider backend={backend}>
                            <Library mobile={mobile} />
                        </OpenApiContextProvider>
                    </Route>
                </Switch>
            )}
        />
    );
};

const App = ({user, editorProps}) => {
    const {sessionId} = useContext(SessionContext);
    const [mobile, setMobile] = useState(false);
    const {width} = useWindowSize();

    useEffect(() => {
        setMobile(width <= 550);
    }, [width]);

    // user prop, when supplied, forwards into AppContextProvider where
    // it overrides the legacy window.username path. When absent, the
    // existing dev / standalone behavior is preserved.
    //
    // editorProps is the §10(e) portal-handoff bag — rightPanelSlots,
    // aiEnabled override, onSpecChange / onCommentAnchorChange. Lives
    // on AppContext so any deeply-nested view (notably ApiView's right
    // column) can read it without prop drilling.
    return (
        <Router>
            {sessionId && (
                <AppContextProvider
                    accessToken={{sessionId, customerId: typeof window !== 'undefined' ? window.customerId : undefined}}
                    user={user}
                    editorProps={editorProps}>
                    <MainRoute mobile={mobile} />
                </AppContextProvider>
            )}
        </Router>
    );
};

export default App;
